




import {Component, Prop, Vue} from 'vue-property-decorator'
import DataGrid, {DataType} from '@/components/DataGrid.vue'
import {reformatDate} from "@/data/sources/dates"
import {executeQuery} from "@/data/repos/query"

@Component({
  components: {
    DataGrid,
  },
})
export default class JobsAllocatedInAMonthDrillDown extends Vue {
  @Prop() public args!: {ppmRepair: number, jobCategory: number, day: number, month: number, year: number, status: number }

  public fields = [
    {name: 'Task_Id', title: 'Task id', dataType: DataType.Number, sort: 1},
    {name: 'Reported_Date_Time', title: 'Reported date', dataType: DataType.Date, sort: 1},
    {name: 'Reporter_Name', title: 'Reporter name', dataType: DataType.Text, sort: 1},
    {name: 'Problem_Short_Desc', title: 'Short description', dataType: DataType.Text, sort: 1},
    {name: 'Site_Desc', title: 'Site', dataType: DataType.Text, sort: 1},
    {name: 'Building_Desc', title: 'Building', dataType: DataType.Text, sort: 1},
    {name: 'Status', title: 'Status', dataType: DataType.Date, sort: 1},
    {name: 'Complete_Date', title: 'Completed', dataType: DataType.Text, sort: 1},
  ]

  public getData(offset: number = 0, limit: number = 250) {
    // @status int,		-- 0 = Not Completed / Outstanding, 1 = Done / Completed, 2 == ALL
    // @ppmRepairAll int	-- 1 = PPM, 2 = Repair
    return executeQuery(
      'FMS_DB',
      'jobsAllocatedInAMonth_Grid',
      this.args,
      this.filter,
      offset, limit)
  }

  private filter(data: any[]): any[] {
    return data.map((v) => {
        return {
          ...v,
          Reported_Date_Time: reformatDate(v.Reported_Date_Time),
          Complete_Date: reformatDate(v.Complete_Date),
        }
      },
    )
  }
}
